"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4904],{

/***/ 59904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



var JsonLd = function(param) {
    var schema = param.schema;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify(schema)
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(JsonLd));


/***/ }),

/***/ 41046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ A; },
  "Tn": function() { return /* binding */ ArticleCard; },
  "dz": function() { return /* binding */ ArticleGrid; },
  "wD": function() { return /* binding */ ArticleList; },
  "aG": function() { return /* binding */ Breadcrumb; },
  "zx": function() { return /* binding */ Button; },
  "gy": function() { return /* binding */ CardGrid; },
  "hf": function() { return /* binding */ ExploreMore; },
  "j4": function() { return /* binding */ Eyebrow; },
  "o4": function() { return /* binding */ FaqSection; },
  "C2": function() { return /* binding */ JournalShell; },
  "$0": function() { return /* binding */ Section; },
  "Ry": function() { return /* binding */ SectionHead; },
  "MP": function() { return /* binding */ TopicHero; },
  "TT": function() { return /* binding */ TopicsGrid; },
  "_2": function() { return /* binding */ renderBlock; }
});

// UNUSED EXPORTS: InstitutionGrid, PAGE_TOPICS, articleHref, articleTag

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./features/products/list/api.ts
var api = __webpack_require__(81525);
// EXTERNAL MODULE: ./libs/app/index.ts + 40 modules
var app = __webpack_require__(41255);
// EXTERNAL MODULE: ./layouts/shared.ts
var shared = __webpack_require__(7806);
;// CONCATENATED MODULE: ./features/journal/search-utils.ts
/** API interceptor unwraps Axios; tolerate the wrapped response used by callers too. */ var productResults = function(response) {
    var data = response === null || response === void 0 ? void 0 : response.data;
    if (Array.isArray(data)) return data;
    var nested = data && typeof data === "object" && "data" in data ? data.data : null;
    return Array.isArray(nested) ? nested : [];
};
var suggestionIndex = function(active, count, direction) {
    if (!count) return -1;
    if (active < 0) return direction === "ArrowDown" ? 0 : count - 1;
    return (active + (direction === "ArrowDown" ? 1 : -1) + count) % count;
};

// EXTERNAL MODULE: ./features/journal/text.ts
var journal_text = __webpack_require__(16356);
;// CONCATENATED MODULE: ./features/journal/search-box.tsx











var SearchBox = function(param) {
    var _defaultValue = param.defaultValue, defaultValue = _defaultValue === void 0 ? "" : _defaultValue, _className = param.className, className = _className === void 0 ? "" : _className, _id = param.id, id = _id === void 0 ? "journal-search" : _id;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(defaultValue), query = ref[0], setQuery = ref[1];
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)([]), items = ref2[0], setItems = ref2[1];
    var ref3 = (0,react.useState)(-1), active = ref3[0], setActive = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react.useState)(false), failed = ref5[0], setFailed = ref5[1];
    (0,react.useEffect)(function() {
        setQuery(defaultValue);
    }, [
        defaultValue
    ]);
    (0,react.useEffect)(function() {
        var controller = new AbortController();
        var current = true;
        setItems([]);
        setActive(-1);
        setFailed(false);
        if (query.trim().length < 2) {
            setLoading(false);
            return function() {
                return controller.abort();
            };
        }
        setLoading(true);
        var deadline = setTimeout(function() {
            if (current) {
                setLoading(false);
                setFailed(true);
            }
        }, 8000);
        var timer = setTimeout(function() {
            var pending = 2;
            var publish = function(promise) {
                void promise.then(function(suggestions) {
                    if (current) setItems(function(previous) {
                        return (0,_to_consumable_array/* default */.Z)(previous).concat((0,_to_consumable_array/* default */.Z)(suggestions)).sort(function(a, b) {
                            return a.kind.localeCompare(b.kind);
                        });
                    });
                }).catch(function() {
                    if (current) setFailed(true);
                }).finally(function() {
                    pending -= 1;
                    if (current && !pending) {
                        clearTimeout(deadline);
                        setLoading(false);
                    }
                });
            };
            publish(fetch("/api/journal-search?q=".concat(encodeURIComponent(query.trim())), {
                signal: controller.signal
            }).then(function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(r) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!r.ok) throw new Error("search");
                                return [
                                    4,
                                    r.json()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().items
                                ];
                        }
                    });
                });
                return function(r) {
                    return _ref.apply(this, arguments);
                };
            }()));
            publish((0,api/* fetchProducts */.t2)({
                offset: 0,
                limit: 4,
                product_keyword: query.trim()
            }).then(function(r) {
                return productResults(r).map(function(p) {
                    var ref, ref1, ref2, ref3;
                    return {
                        id: "product-".concat(p.id),
                        title: (0,journal_text/* plainText */.Kd)(p.product_name),
                        href: shared/* PagePath.ProductDetailPage.replace */._.ProductDetailPage.replace("[id]", encodeURIComponent("".concat((0,app/* createHandle */.UR)(p.product_name), "-").concat(p.id, "-").concat(p.product_code))),
                        kind: "Sản phẩm",
                        image: ((ref1 = (ref = p.images) === null || ref === void 0 ? void 0 : ref.find(function(image) {
                            return image.avatar;
                        })) === null || ref1 === void 0 ? void 0 : ref1.url) || ((ref2 = p.images) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.url) || p.image || null
                    };
                });
            }));
        }, 250);
        return function() {
            current = false;
            clearTimeout(deadline);
            clearTimeout(timer);
            controller.abort();
        };
    }, [
        query
    ]);
    var visible = open && query.trim().length >= 2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        action: "/tin-tuc/",
        method: "get",
        role: "search",
        className: "tw-relative ".concat(className),
        onBlur: function(e) {
            if (!e.currentTarget.contains(e.relatedTarget)) setOpen(false);
        },
        onSubmit: function(e) {
            var ref;
            if (((ref = e.nativeEvent.submitter) === null || ref === void 0 ? void 0 : ref.getAttribute("name")) !== "all" && visible && active >= 0 && items[active]) {
                e.preventDefault();
                setOpen(false);
                void router.push(items[active].href);
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-items-center tw-rounded-md tw-border tw-border-[#D8CFBC] tw-bg-white focus-within:tw-border-jr-green focus-within:tw-ring-2 focus-within:tw-ring-emerald-50",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "submit",
                        "aria-label": "T\xecm kiếm",
                        className: "tw-pl-4 tw-pr-2 tw-text-jr-green tw-bg-transparent tw-border-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            width: "18",
                            height: "18",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "1.6",
                            "aria-hidden": "true",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "10.5",
                                    cy: "10.5",
                                    r: "6.5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "m16 16 5 5"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "search",
                        name: "q",
                        value: query,
                        autoComplete: "off",
                        placeholder: "T\xecm sản phẩm, b\xe0i viết…",
                        "aria-label": "T\xecm sản phẩm, b\xe0i viết",
                        role: "combobox",
                        "aria-autocomplete": "list",
                        "aria-expanded": visible,
                        "aria-controls": "".concat(id, "-results"),
                        "aria-activedescendant": active >= 0 ? "".concat(id, "-").concat(active) : undefined,
                        onFocus: function() {
                            return setOpen(true);
                        },
                        onChange: function(e) {
                            setQuery(e.target.value);
                            setOpen(true);
                        },
                        onKeyDown: function(e) {
                            if (e.key === "Escape") {
                                setOpen(false);
                                setActive(-1);
                            } else if ([
                                "ArrowDown",
                                "ArrowUp"
                            ].includes(e.key)) {
                                e.preventDefault();
                                setOpen(true);
                                if (items.length) setActive(function(a) {
                                    return suggestionIndex(a, items.length, e.key);
                                });
                            }
                        },
                        className: "tw-h-[38px] tw-w-full tw-min-w-0 tw-rounded-r-md tw-border-0 tw-bg-transparent tw-pr-3 tw-text-[16px] sm:tw-text-[13px] tw-text-jr-ink focus:tw-outline-none"
                    })
                ]
            }),
            visible && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-absolute tw-right-0 tw-top-full tw-mt-2 tw-w-[340px] tw-max-w-[calc(100vw-40px)] tw-rounded-md tw-border tw-border-jr-line tw-bg-white tw-shadow-xl tw-overflow-hidden tw-z-50",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        role: "status",
                        className: "tw-px-4 tw-py-3 tw-text-xs tw-text-jr-mute",
                        children: loading ? "Đang t\xecm kiếm…" : failed ? "Một số gợi \xfd chưa tải được. Bạn c\xf3 thể thử lại." : items.length ? "Gợi \xfd ph\xf9 hợp" : "Chưa t\xecm thấy kết quả ph\xf9 hợp."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        id: "".concat(id, "-results"),
                        role: "listbox",
                        "aria-label": "Gợi \xfd t\xecm kiếm",
                        className: "tw-m-0 tw-p-0 tw-list-none tw-max-h-[min(55vh,420px)] tw-overflow-y-auto",
                        children: items.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                id: "".concat(id, "-").concat(index),
                                role: "option",
                                "aria-selected": active === index,
                                className: active === index ? "tw-bg-emerald-50" : "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: item.href,
                                    onMouseEnter: function() {
                                        return setActive(index);
                                    },
                                    onClick: function() {
                                        return setOpen(false);
                                    },
                                    className: "tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-3 hover:tw-bg-emerald-50 tw-text-jr-ink",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-flex tw-h-14 tw-w-14 tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-lg tw-border tw-border-jr-line tw-bg-jr-band",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: item.image || "/logo.svg",
                                                alt: "",
                                                loading: "lazy",
                                                onError: function(event) {
                                                    if (event.currentTarget.dataset.fallback) return;
                                                    event.currentTarget.dataset.fallback = "true";
                                                    event.currentTarget.src = "/logo.svg";
                                                    event.currentTarget.style.objectFit = "contain";
                                                    event.currentTarget.style.padding = "6px";
                                                },
                                                className: "tw-h-full tw-w-full ".concat(item.image ? "tw-object-cover" : "tw-object-contain tw-p-1.5")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "tw-min-w-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "tw-block tw-text-[11px] tw-text-jr-green",
                                                    children: item.kind
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "tw-text-sm tw-line-clamp-2",
                                                    children: item.title
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, item.id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "submit",
                        name: "all",
                        className: "tw-w-full tw-border-0 tw-border-t tw-border-jr-line tw-bg-jr-bg tw-px-4 tw-py-3 tw-text-left tw-text-sm tw-text-jr-green",
                        children: "Xem tất cả b\xe0i viết →"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./features/journal/market-pages.ts
var market_pages = __webpack_require__(71744);
;// CONCATENATED MODULE: ./features/journal/gia-lookup-link.tsx




var GiaLookupLink = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: market_pages/* GIA_LOOKUP_HREF */.QZ,
        prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "tw-inline-flex tw-min-h-[40px] tw-shrink-0 tw-items-center tw-justify-center tw-gap-1.5 tw-whitespace-nowrap tw-rounded-md tw-border tw-border-[#146557] tw-bg-[#146557] tw-px-2.5 tw-py-2 tw-text-[12px] sm:tw-text-[13px] tw-font-medium tw-text-white hover:tw-bg-[#0D5145] hover:tw-text-white focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-[#A68A59] ".concat(className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "1.5",
                    className: "tw-hidden sm:tw-block tw-h-4 tw-w-4 tw-shrink-0",
                    "aria-hidden": "true",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M5 3h9l5 5v13H5V3Z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M14 3v5h5M8 12h8m-8 4h5"
                        })
                    ]
                }),
                "Tra cứu GIA"
            ]
        })
    });
};

// EXTERNAL MODULE: ./features/home/partials/ConsultGuest/index.tsx + 1 modules
var ConsultGuest = __webpack_require__(18276);
// EXTERNAL MODULE: ./libs/cookies/index.ts
var cookies = __webpack_require__(60377);
// EXTERNAL MODULE: ./components/ui/Link/index.tsx
var Link = __webpack_require__(43701);
// EXTERNAL MODULE: ./components/ui/Icon/index.tsx
var Icon = __webpack_require__(58262);
// EXTERNAL MODULE: ./components/icons/Bell/index.tsx
var Bell = __webpack_require__(26426);
// EXTERNAL MODULE: ./components/icons/User/index.tsx
var User = __webpack_require__(94423);
// EXTERNAL MODULE: ./contexts/profile/index.tsx
var contexts_profile = __webpack_require__(48309);
// EXTERNAL MODULE: ./features/notifications/list/api.ts
var list_api = __webpack_require__(86270);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./constants/business.ts
var business = __webpack_require__(56154);
// EXTERNAL MODULE: ./features/journal/const.ts
var journal_const = __webpack_require__(89365);
;// CONCATENATED MODULE: ./features/journal/components.tsx

















/* ------------------------------------------------------------------ */ /* Nhỏ gọn dùng chung                                                  */ /* ------------------------------------------------------------------ */ var articleHref = function(a) {
    return "/article/".concat(a.slug, "/");
};
var fmtDate = function(d) {
    return dayjs_min_default()(d).isValid() ? dayjs_min_default()(d).format("DD/MM/YYYY") : "";
};
var A = function(param) {
    var href = param.href, _className = param.className, className = _className === void 0 ? "" : _className, children = param.children, _current = param.current, current = _current === void 0 ? false : _current;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: className,
            "aria-current": current ? "page" : undefined,
            children: children
        })
    });
};
var serif = "tw-font-jr";
var wrap = "tw-mx-auto tw-w-full tw-max-w-[1296px] tw-px-5 md:tw-px-8";
var Eyebrow = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: "tw-m-0 tw-text-[12px] tw-font-medium tw-uppercase tw-tracking-[0.08em] tw-text-jr-gold ".concat(className),
        children: children
    });
};
var H2 = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
        className: "".concat(serif, " tw-m-0 tw-text-[28px] md:tw-text-[40px] tw-font-normal tw-leading-[1.2] tw-text-jr-ink ").concat(className),
        children: children
    });
};
var Arrow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        "aria-hidden": "true",
        children: "→"
    });
};
var TextLink = function(param) {
    var href = param.href, children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(A, {
        href: href,
        className: "tw-inline-flex tw-items-center tw-gap-2 tw-text-[15px] tw-font-medium tw-text-jr-green hover:tw-underline ".concat(className),
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {})
        ]
    });
};
var Button = function(param) {
    var href = param.href, _tone = param.tone, tone = _tone === void 0 ? "green" : _tone, children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    var tones = {
        green: "tw-bg-jr-green tw-text-white",
        gold: "tw-bg-jr-gold tw-text-white",
        plum: "tw-bg-jr-plum tw-text-white",
        light: "tw-bg-white tw-text-jr-green tw-border tw-border-jr-line"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(A, {
        href: href,
        className: "tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-min-h-[48px] tw-px-7 tw-text-[15px] tw-font-medium hover:tw-opacity-90 ".concat(tones[tone], " ").concat(className),
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {})
        ]
    });
};
/* ------------------------------------------------------------------ */ /* Khung trang: thanh trên, header, footer                             */ /* ------------------------------------------------------------------ */ /**
 * Góc tài khoản của header trang tin.
 * - đã đăng nhập: chuông thông báo (chấm đỏ khi có mới) + avatar/tên; chưa: icon người + "Đăng nhập"
 */ var AccountLink = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    var ref = (0,react.useState)(false), isAuth = ref[0], setIsAuth = ref[1];
    var ref1 = (0,react.useState)(0), totalNotification = ref1[0], setTotalNotification = ref1[1];
    var profile = (0,contexts_profile/* useProfile */.Un)();
    var ref2 = (0,list_api/* useFetchTotalByTab */.Wh)({
        enabled: false,
        refetchOnWindowFocus: false,
        retry: false,
        onSuccess: function onSuccess(param) {
            var data = param.data;
            setTotalNotification(Object.values(data || {}).reduce(function(a, b) {
                return a + (+b || 0);
            }, 0));
        }
    }), refetchTotalByTab = ref2.refetch;
    (0,react.useEffect)(function() {
        var auth = false;
        try {
            auth = !!(0,cookies/* getAuth */.v0)().isAuth;
        } catch (_e) {
            auth = false;
        }
        setIsAuth(auth);
        if (auth) refetchTotalByTab();
    }, [
        refetchTotalByTab
    ]);
    var color = {
        color: "#38544B"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-min-w-0 tw-items-center tw-gap-x-3 ".concat(className),
        children: isAuth ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                    url: shared/* PagePath.NotificationsPage */._.NotificationsPage,
                    className: "tw-flex tw-h-10 tw-w-10 tw-shrink-0 tw-items-center tw-justify-center",
                    title: "Th\xf4ng b\xe1o",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-relative tw-w-6 tw-h-6",
                        children: [
                            totalNotification > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-w-2 tw-h-2 tw-bg-danger-main tw-rounded-full tw-absolute tw-right-0 tw-top-0 tw-z-10"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bell/* BellOutlineIcon */.K, {}),
                                style: color
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                    url: shared/* PagePath.AccountProfilePage */._.AccountProfilePage,
                    title: profile && profile.avatar ? "C\xe1 nh\xe2n" : "T\xe0i khoản",
                    children: profile && profile.avatar ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-gap-x-2.5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-h-8 tw-w-8 tw-shrink-0 tw-rounded-full tw-border tw-border-jr-line tw-bg-center tw-bg-cover tw-bg-no-repeat",
                                style: {
                                    backgroundImage: "url('".concat(profile.avatar, "')")
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-max-w-[132px] tw-truncate tw-text-[14px] tw-font-medium",
                                style: color,
                                children: profile.fullname
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-h-8 tw-w-8 tw-rounded-full tw-bg-center tw-bg-contain tw-bg-no-repeat tw-border tw-border-jr-line",
                        style: {
                            backgroundImage: "url(/logo.svg)"
                        }
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
            url: shared/* PagePath.LoginPage */._.LoginPage,
            title: "login",
            className: "tw-flex tw-min-h-[40px] tw-items-center tw-gap-x-2",
            style: color,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(User/* UserOutlineIcon */.V, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "tw-text-[14px] tw-font-medium",
                    children: "Đăng nhập"
                })
            ]
        })
    });
};
var JournalShell = function(param) {
    var activeKey = param.activeKey, children = param.children;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-bg-jr-bg tw-text-jr-ink tw-font-sans",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: "tw-bg-[#F8F5ED] tw-relative tw-z-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(wrap, " tw-grid tw-grid-cols-[minmax(0,1fr)_auto_auto] md:tw-grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] tw-items-center tw-gap-2 md:tw-gap-4 tw-h-[64px] md:tw-h-[76px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(A, {
                                href: "/",
                                className: "tw-col-start-1 md:tw-col-start-2 tw-row-start-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/logo.svg",
                                    alt: "An Thư The Diamond Store",
                                    className: "tw-h-[32px] md:tw-h-[50px] tw-w-auto"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GiaLookupLink, {
                                className: "tw-col-start-2 md:tw-col-start-1 tw-row-start-1 tw-justify-self-end md:tw-justify-self-start"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLink, {
                                className: "tw-col-start-3 tw-row-start-1 tw-justify-self-end tw-hidden lg:tw-inline-flex"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-col-start-3 tw-row-start-1 tw-justify-self-end tw-flex lg:tw-hidden tw-items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    "aria-label": open ? "Đ\xf3ng menu" : "Mở menu",
                                    "aria-expanded": open,
                                    "aria-controls": "journal-mobile-menu",
                                    onClick: function() {
                                        return setOpen(function(v) {
                                            return !v;
                                        });
                                    },
                                    className: "tw-flex tw-h-11 tw-w-11 tw-flex-col tw-items-center tw-justify-center tw-gap-[5px] tw-rounded-full tw-border tw-border-jr-line tw-bg-white focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-jr-green",
                                    children: open ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8",
                                        className: "tw-text-jr-green",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "m6 6 12 12M18 6 6 18"
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-block tw-h-[2px] tw-w-5 tw-bg-jr-green"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-block tw-h-[2px] tw-w-5 tw-bg-jr-green"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-block tw-h-[2px] tw-w-5 tw-bg-jr-green"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "tw-hidden lg:tw-block tw-bg-jr-green",
                        "aria-label": "Điều hướng ch\xednh",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(wrap, " tw-flex tw-items-stretch tw-justify-between tw-gap-4 xl:tw-gap-8"),
                            children: journal_const/* NAV_ITEMS.map */.cx.map(function(n) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(A, {
                                    href: n.href,
                                    current: activeKey === n.key,
                                    className: "tw-flex tw-min-h-[52px] tw-items-center tw-justify-center tw-whitespace-nowrap tw-border-b-[3px] tw-px-2 xl:tw-px-3 tw-py-3 tw-text-[14px] xl:tw-text-[15px] tw-font-medium tw-transition-colors hover:tw-text-white hover:tw-border-[#D7BD80] focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-[-4px] focus-visible:tw-outline-[#D7BD80] ".concat(activeKey === n.key ? "tw-text-white tw-border-[#D7BD80]" : "tw-text-[#F3F0E7] tw-border-transparent"),
                                    children: n.label
                                }, n.key);
                            })
                        })
                    }),
                    open && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "journal-mobile-menu",
                        className: "lg:tw-hidden tw-absolute tw-left-0 tw-right-0 tw-top-full tw-bg-jr-green tw-shadow-lg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                className: "".concat(wrap, " tw-py-2 tw-flex tw-flex-col"),
                                "aria-label": "Điều hướng ch\xednh",
                                children: journal_const/* NAV_ITEMS.map */.cx.map(function(n) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(A, {
                                        href: n.href,
                                        current: activeKey === n.key,
                                        className: "tw-flex tw-min-h-[52px] tw-items-center tw-border-b tw-border-b-white/20 tw-border-l-[3px] tw-px-4 tw-py-3 tw-text-[16px] tw-font-medium hover:tw-text-white focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-[-4px] focus-visible:tw-outline-[#D7BD80] ".concat(activeKey === n.key ? "tw-text-white tw-border-l-[#D7BD80]" : "tw-text-[#F3F0E7] tw-border-l-transparent"),
                                        children: n.label
                                    }, n.key);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-bg-[#F8F5ED]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(wrap, " tw-py-4"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLink, {
                                        className: "tw-flex tw-text-[16px]"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JournalFooter, {})
        ]
    });
};
var Breadcrumb = function(param) {
    var items = param.items, _searchQuery = param.searchQuery, searchQuery = _searchQuery === void 0 ? "" : _searchQuery;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-bg-[#F8F5ED] tw-border-b tw-border-solid tw-border-[#D8CFBC]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat(wrap, " tw-flex tw-flex-col sm:tw-flex-row tw-items-stretch sm:tw-items-center tw-justify-between tw-gap-3 sm:tw-gap-6 tw-min-h-[60px] tw-py-2.5 tw-text-[13px] tw-text-jr-mute"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                    "aria-label": "Breadcrumb",
                    className: "tw-flex tw-min-w-0 tw-flex-1 tw-flex-wrap tw-items-center tw-gap-x-2",
                    children: items.map(function(it, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                i > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "aria-hidden": "true",
                                    className: "tw-text-jr-gold/60",
                                    children: "/"
                                }),
                                it.href ? /*#__PURE__*/ (0,jsx_runtime.jsx)(A, {
                                    href: it.href,
                                    className: "tw-text-jr-mute hover:tw-text-jr-green hover:tw-underline",
                                    children: it.label
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: i === items.length - 1 ? "tw-font-medium tw-text-jr-green" : "",
                                    children: it.label
                                })
                            ]
                        }, it.label);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBox, {
                    id: "journal-breadcrumb-search",
                    defaultValue: searchQuery,
                    className: "tw-w-full sm:tw-w-[300px] lg:tw-w-[320px] tw-shrink-0"
                })
            ]
        })
    });
};
/** Khối tư vấn dùng chung với Home (design/AnThu-Home-TuVan): form 3 trường + chat guest, đã đăng nhập thì bấm tư vấn luôn. */ var ConsultBand = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsultGuest/* default */.Z, {
        variant: "journal"
    });
};
var JournalFooter = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsultBand, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                className: "tw-bg-jr-ink tw-text-[#e8e4da]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(wrap, " tw-grid tw-gap-8 md:tw-grid-cols-4 tw-py-10 md:tw-py-12"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/logo-white.svg",
                                        alt: "An Thư",
                                        className: "tw-h-[46px] tw-w-auto"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-mt-4 tw-mb-0 tw-text-[15px]",
                                        children: "Trang sức kim cương tự nhi\xean"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-text-[15px] tw-leading-relaxed",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-m-0 tw-text-[17px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "tel:0333336789",
                                            className: "tw-text-inherit",
                                            children: "Hotline: 033 333 6789"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-mt-3 tw-mb-0",
                                        children: "89A Nguyễn Tr\xe3i, Phường Bến Th\xe0nh, TP. Hồ Ch\xed Minh"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-mt-3 tw-mb-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A, {
                                            href: "/",
                                            className: "tw-text-inherit",
                                            children: "anthu.vn"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "tw-m-0 tw-p-0 tw-list-none tw-text-[15px] tw-leading-[2.2]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A, {
                                            href: "/ve-an-thu/",
                                            className: "tw-text-inherit hover:tw-underline",
                                            children: "Về An Thư"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A, {
                                            href: "/shops/",
                                            className: "tw-text-inherit hover:tw-underline",
                                            children: "Hệ thống cửa h\xe0ng"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A, {
                                            href: "/policies/product-warranty/",
                                            className: "tw-text-inherit hover:tw-underline",
                                            children: "Ch\xednh s\xe1ch"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "tw-m-0 tw-p-0 tw-list-none tw-text-[15px] tw-leading-[2]",
                                children: [
                                    [
                                        "Facebook",
                                        business/* BUSINESS.social.facebook */.aL.social.facebook
                                    ],
                                    [
                                        "TikTok",
                                        business/* BUSINESS.social.tiktok */.aL.social.tiktok
                                    ],
                                    [
                                        "YouTube",
                                        business/* BUSINESS.social.youtube */.aL.social.youtube
                                    ],
                                    [
                                        "Instagram",
                                        business/* BUSINESS.social.instagram */.aL.social.instagram
                                    ], 
                                ].map(function(param) {
                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), name = _param[0], url = _param[1];
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: url,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            "aria-label": "An Thư tr\xean ".concat(name),
                                            className: "tw-text-inherit hover:tw-underline",
                                            children: name
                                        })
                                    }, name);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(wrap),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-gap-2 tw-border-t tw-border-[#3a3a3a] tw-py-6 tw-text-[13px] tw-text-[#bdb8ac]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "C\xf4ng ty TNHH An Thư The Diamond Store \xa0|\xa0 MST 0314503621"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "\xa9 ",
                                        new Date().getFullYear(),
                                        " An Thư"
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* ------------------------------------------------------------------ */ /* Thẻ bài viết + lưới                                                  */ /* ------------------------------------------------------------------ */ var articleTag = function(a) {
    return a.press ? "B\xc1O CH\xcd" : a.news && !a.promotion ? "TIN AN THƯ" : a.topics[0] ? journal_const/* TOPIC_BY_SLUG */.wp[a.topics[0]].tag : "TIN TỨC";
};
var ArticleCard = function(param) {
    var a = param.a, _fit = param.fit, fit = _fit === void 0 ? "cover" : _fit, _showDate = param.showDate, showDate = _showDate === void 0 ? false : _showDate;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: "tw-flex tw-flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(A, {
                href: articleHref(a),
                className: "tw-block",
                children: a.image ? fit === "poster" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex tw-h-[240px] md:tw-h-[260px] tw-items-start tw-justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: a.image,
                        alt: a.title,
                        loading: "lazy",
                        className: "tw-h-full tw-w-auto tw-max-w-full tw-object-contain"
                    })
                }) : /* eslint-disable-next-line @next/next/no-img-element */ /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: a.image,
                    alt: "",
                    loading: "lazy",
                    onError: function(e) {
                        e.currentTarget.style.visibility = "hidden";
                    },
                    className: a.press ? "tw-aspect-[16/9] tw-h-auto tw-w-full tw-object-contain tw-bg-jr-band" : "tw-h-[180px] md:tw-h-[190px] tw-w-full tw-object-cover tw-bg-jr-band"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: a.press ? "tw-aspect-[16/9] tw-bg-jr-band" : "tw-h-[180px] tw-bg-jr-band"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-mt-5",
                children: [
                    showDate ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0 tw-text-[13px] tw-text-jr-gold",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                            dateTime: a.date,
                            children: fmtDate(a.date)
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Eyebrow, {
                        children: articleTag(a)
                    }),
                    a.source && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "tw-mt-2 tw-mb-0 tw-text-xs tw-text-jr-mute",
                        children: [
                            "Nguồn: ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: a.source.href,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "hover:tw-underline",
                                children: [
                                    a.source.label,
                                    " ↗"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "".concat(serif, " tw-mt-2 tw-mb-0 tw-text-[20px] md:tw-text-[22px] tw-font-normal tw-leading-[1.3]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A, {
                            href: articleHref(a),
                            className: "tw-text-jr-ink hover:tw-text-jr-green",
                            children: a.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink, {
                            href: articleHref(a),
                            children: "Đọc b\xe0i viết"
                        })
                    })
                ]
            })
        ]
    });
};
var ArticleGrid = function(param) {
    var items = param.items, fit = param.fit, showDate = param.showDate;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-grid tw-gap-x-5 tw-gap-y-10 sm:tw-grid-cols-2 lg:tw-grid-cols-3",
        children: items.map(function(a) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCard, {
                a: a,
                fit: fit,
                showDate: showDate
            }, a.id);
        })
    });
};
var SectionHead = function(param) {
    var _eyebrow = param.eyebrow, eyebrow = _eyebrow === void 0 ? "G\xd3C AN THƯ" : _eyebrow, title = param.title, lead = param.lead;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-mb-8 md:tw-mb-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Eyebrow, {
                children: eyebrow
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(H2, {
                className: "tw-mt-3",
                children: title
            }),
            lead && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "tw-mt-3 tw-mb-0 tw-text-[17px] tw-text-jr-mute",
                children: lead
            })
        ]
    });
};
var Section = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className, id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: id,
        className: "tw-py-12 md:tw-py-16 ".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: wrap,
            children: children
        })
    });
};
var FaqSection = function(param) {
    var items = param.items;
    return items.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
        id: "hoi-dap",
        className: "!tw-pt-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHead, {
                title: "C\xe2u hỏi thường gặp"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                className: "tw-m-0 tw-grid tw-gap-x-10 tw-gap-y-8 md:tw-grid-cols-3",
                children: items.map(function(f) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-border-t tw-border-jr-line tw-pt-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                className: "".concat(serif, " tw-text-[20px] tw-leading-snug"),
                                children: f.q
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                className: "tw-m-0 tw-mt-3 tw-text-[16px] tw-leading-relaxed tw-text-jr-mute",
                                children: f.a
                            })
                        ]
                    }, f.q);
                })
            })
        ]
    }) : null;
};
var icoProps = {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#AF9454",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true
};
var EXPLORE = [
    {
        slug: "bang-gia",
        title: "Bảng gi\xe1",
        sub: "V\xe0ng \xb7 Ngoại tệ \xb7 Kim cương",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, icoProps), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "3",
                    y: "13",
                    width: "4",
                    height: "8"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "10",
                    y: "8",
                    width: "4",
                    height: "13"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "17",
                    y: "3",
                    width: "4",
                    height: "18"
                })
            ]
        }))
    },
    {
        slug: "kiem-dinh",
        title: "Kiểm định",
        sub: "GIA \xb7 IGI \xb7 Chứng thư",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, icoProps), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "5",
                    y: "3",
                    width: "14",
                    height: "18",
                    rx: "1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M9 8h6M9 12h6M9 16h4"
                })
            ]
        }))
    },
    {
        slug: "kim-cuong",
        title: "Kim cương",
        sub: "4C \xb7 Li & carat",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, icoProps), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M6 3h12l4 6-10 12L2 9z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M2 9h20M9 3l-2 6 5 12M15 3l2 6-5 12"
                })
            ]
        }))
    },
    {
        slug: "nhan-cuoi",
        title: "Nhẫn cưới",
        sub: "Cầu h\xf4n \xb7 Đo ni",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, icoProps), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "9",
                    cy: "12",
                    r: "6"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "15",
                    cy: "12",
                    r: "6"
                })
            ]
        }))
    },
    {
        slug: "trang-suc",
        title: "Trang sức",
        sub: "Phong c\xe1ch \xb7 Qu\xe0 tặng",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, icoProps), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M6 3h12l4 6-10 12L2 9z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M2 9h20"
                })
            ]
        }))
    },
    {
        slug: "vang-bao-quan",
        title: "V\xe0ng & bảo quản",
        sub: "Chất liệu \xb7 Chăm s\xf3c",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, icoProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 3v18M3 12h18M5.6 5.6l12.8 12.8M18.4 5.6L5.6 18.4"
            })
        }))
    }, 
];
var ExploreMore = function(param) {
    var exclude = param.exclude;
    var items = EXPLORE.filter(function(t) {
        return t.slug !== exclude;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        className: "!tw-pt-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-border-0 tw-border-t tw-border-solid tw-border-jr-line tw-pt-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "".concat(serif, " tw-m-0 tw-text-[26px] md:tw-text-[32px] tw-font-normal tw-text-jr-ink"),
                    children: "Kh\xe1m ph\xe1 c\xf9ng An Thư"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-mt-6 tw-grid tw-grid-cols-2 md:tw-grid-cols-3 ".concat(items.length === 5 ? "lg:tw-grid-cols-5" : "lg:tw-grid-cols-6", " tw-gap-3 md:tw-gap-4"),
                    children: items.map(function(t) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(A, {
                            href: t.slug === "bang-gia" ? "/bang-gia/" : (0,journal_const/* topicHref */.hR)(t.slug),
                            className: "tw-group tw-flex tw-flex-col tw-justify-between tw-min-h-[124px] tw-border tw-border-solid tw-border-[#DECA95]/70 tw-bg-white tw-p-4 hover:tw-border-[#AF9454]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "tw-flex tw-items-start tw-justify-between",
                                    children: [
                                        t.icon,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            "aria-hidden": "true",
                                            className: "tw-text-jr-green",
                                            children: "→"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "".concat(serif, " tw-block tw-text-[19px] tw-leading-tight tw-text-jr-green group-hover:tw-underline"),
                                            children: t.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-mt-3 tw-block tw-text-[12px] tw-text-jr-mute",
                                            children: t.sub
                                        })
                                    ]
                                })
                            ]
                        }, t.slug);
                    })
                })
            ]
        })
    });
};
/** Danh sách bài có nút "Xem thêm" (ẩn/hiện phía client). */ var ArticleList = function(param) {
    var items = param.items, intro = param.intro, _initial = param.initial, initial = _initial === void 0 ? 6 : _initial;
    var first = intro ? initial - 1 : initial;
    var ref = (0,react.useState)(first), count = ref[0], setCount = ref[1];
    var shown = items.slice(0, count);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-grid tw-gap-x-5 tw-gap-y-10 sm:tw-grid-cols-2 lg:tw-grid-cols-3",
                children: [
                    intro && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-bg-jr-band tw-p-8 tw-self-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Eyebrow, {
                                children: "G\xd3C AN THƯ"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "".concat(serif, " tw-mt-3 tw-mb-0 tw-text-[28px] tw-leading-[1.25]"),
                                children: [
                                    "Kiến thức",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "để lựa chọn."
                                ]
                            })
                        ]
                    }),
                    shown.map(function(a) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCard, {
                            a: a
                        }, a.id);
                    })
                ]
            }),
            items.length > count && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-mt-10 tw-text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    onClick: function() {
                        return setCount(function(c) {
                            return c + 6;
                        });
                    },
                    className: "tw-min-h-[48px] tw-border tw-border-jr-green tw-bg-transparent tw-px-8 tw-text-[15px] tw-font-medium tw-text-jr-green hover:tw-bg-jr-green hover:tw-text-white",
                    children: "Xem th\xeam b\xe0i viết"
                })
            }),
            items.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "tw-text-jr-mute",
                children: "B\xe0i viết sẽ sớm được cập nhật."
            })
        ]
    });
};
/* ------------------------------------------------------------------ */ /* Hero chuyên đề                                                       */ /* ------------------------------------------------------------------ */ var heroBg = {
    beige: "tw-bg-jr-band",
    dark: "tw-bg-[#0b0b0b] tw-text-white",
    rose: "tw-bg-jr-rose",
    plain: "tw-bg-jr-bg"
};
var TopicHero = function(param) {
    var topic = param.topic, cover = param.cover;
    var h = topic.hero;
    var dark = h.tone === "dark";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: heroBg[h.tone],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat(wrap, " tw-grid tw-items-center tw-gap-8 ").concat(h.image ? "md:tw-grid-cols-2" : "", " tw-py-10 md:tw-py-14"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-max-w-[520px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Eyebrow, {
                            children: h.eyebrow
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "".concat(serif, " tw-mt-4 tw-mb-0 tw-text-[34px] md:tw-text-[52px] tw-font-normal tw-leading-[1.15] ").concat(dark ? "tw-text-white" : "tw-text-jr-ink"),
                            children: h.title.map(function(l, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        i > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                            className: "tw-hidden md:tw-block"
                                        }),
                                        " ",
                                        l
                                    ]
                                }, l);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "tw-mt-5 tw-mb-0 tw-text-[17px] md:tw-text-[19px] tw-leading-relaxed ".concat(dark ? "tw-text-[#d7d3c8]" : "tw-text-jr-mute"),
                            children: h.lead
                        }),
                        h.cta && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-mt-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                href: h.cta.href,
                                tone: h.cta.tone,
                                children: h.cta.label
                            })
                        })
                    ]
                }),
                h.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex tw-justify-center md:tw-justify-end",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: h.image,
                        alt: topic.title,
                        width: 520,
                        height: h.imageContain ? 258 : 520,
                        className: "tw-w-full tw-max-w-[520px] ".concat(h.imageContain ? "tw-h-auto tw-bg-white" : "tw-aspect-square tw-object-cover")
                    })
                })
            ]
        })
    });
};
/* ------------------------------------------------------------------ */ /* Các khối nội dung của trang chuyên đề                                */ /* ------------------------------------------------------------------ */ var CardGrid = function(param) {
    var cols = param.cols, items = param.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-grid tw-gap-4 sm:tw-grid-cols-2 ".concat(cols === 4 ? "lg:tw-grid-cols-4" : "lg:tw-grid-cols-3"),
        children: items.map(function(c) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-bg-jr-band tw-p-6 tw-flex tw-flex-col tw-justify-between tw-min-h-[150px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "".concat(serif, " tw-m-0 tw-text-[22px] tw-font-normal tw-leading-snug"),
                                children: c.title
                            }),
                            c.desc && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-mt-2 tw-mb-0 tw-text-[15px] tw-text-jr-mute",
                                children: c.desc
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink, {
                            href: c.href,
                            children: c.label || "Kh\xe1m ph\xe1"
                        })
                    })
                ]
            }, c.title);
        })
    });
};
var InstitutionGrid = function(param) {
    var items = param.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 lg:tw-grid-cols-5 tw-gap-3",
        children: items.map(function(n) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-border tw-border-jr-line tw-bg-white tw-p-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "".concat(serif, " tw-m-0 tw-text-[24px] tw-font-normal"),
                        children: n
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink, {
                            href: "/tin-tuc/?q=".concat(encodeURIComponent(n)),
                            children: "T\xecm hiểu"
                        })
                    })
                ]
            }, n);
        })
    });
};
var renderBlock = function(b, ctx) {
    var topic = ctx.topic, articles = ctx.articles, key = ctx.key;
    switch(b.type){
        case "cards":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                className: "!tw-py-8 md:!tw-py-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardGrid, {
                    cols: b.cols,
                    items: b.items
                })
            }, key);
        case "steps":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHead, {
                        title: b.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-grid tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-x-8 tw-gap-y-8",
                        children: b.items.map(function(s, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-border-b tw-border-jr-line tw-pb-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-m-0 tw-text-[12px] tw-text-jr-gold",
                                        children: String(i + 1).padStart(2, "0")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "".concat(serif, " tw-mt-4 tw-mb-0 tw-text-[28px] tw-font-normal"),
                                        children: s.en
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-mt-3 tw-mb-0 tw-text-[16px] tw-text-jr-mute",
                                        children: s.vi
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-mt-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink, {
                                            href: s.href,
                                            children: "T\xecm hiểu"
                                        })
                                    })
                                ]
                            }, s.en);
                        })
                    })
                ]
            }, key);
        case "sizePanel":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                className: "!tw-pt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-grid tw-gap-8 md:tw-grid-cols-2 tw-bg-jr-band tw-p-6 md:tw-p-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Eyebrow, {
                                    children: "K\xcdCH THƯỚC & TRỌNG LƯỢNG"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(H2, {
                                    className: "tw-mt-3 !tw-text-[32px] md:!tw-text-[40px]",
                                    children: "Li ↔ carat"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-mt-4 tw-mb-0 tw-text-[17px] tw-text-jr-mute",
                                    children: "T\xecm hiểu k\xedch thước v\xe0 trọng lượng trước khi chọn vi\xean kim cương."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-self-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-grid tw-grid-cols-2 tw-gap-6 tw-border-b tw-border-jr-line tw-pb-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "".concat(serif, " tw-m-0 tw-text-[20px]"),
                                                    children: "Li / mm"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "tw-mt-2 tw-mb-0 tw-text-[15px] tw-text-jr-mute",
                                                    children: "K\xedch thước"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "".concat(serif, " tw-m-0 tw-text-[20px]"),
                                                    children: "Carat"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "tw-mt-2 tw-mb-0 tw-text-[15px] tw-text-jr-mute",
                                                    children: "Trọng lượng"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-mt-5 tw-mb-0 tw-text-[16px] tw-text-jr-mute",
                                    children: "Hỏi An Thư để đối chiếu th\xf4ng số của từng vi\xean."
                                })
                            ]
                        })
                    ]
                })
            }, key);
        case "institutions":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHead, {
                        title: b.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InstitutionGrid, {
                        items: b.items
                    })
                ]
            }, key);
        case "readGuide":
            {
                var first = articles[0];
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                    className: "!tw-pt-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHead, {
                            title: b.title,
                            lead: b.lead
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-grid tw-gap-10 lg:tw-grid-cols-[1.4fr_1fr] tw-items-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: topic.hero.image,
                                            alt: "Mẫu giấy kiểm định kim cương",
                                            className: "tw-w-full tw-h-auto tw-bg-white tw-border tw-border-jr-line"
                                        }),
                                        first && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-mt-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                                href: articleHref(first),
                                                children: b.cta
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                                    className: "tw-m-0 tw-p-0 tw-list-none",
                                    children: b.steps.map(function(s, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "tw-grid tw-grid-cols-[36px_1fr] tw-gap-3 tw-border-b tw-border-jr-line tw-py-5 first:tw-pt-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "tw-text-[12px] tw-text-jr-gold tw-pt-2",
                                                    children: String(i + 1).padStart(2, "0")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "".concat(serif, " tw-m-0 tw-text-[24px] tw-font-normal"),
                                                            children: s.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "tw-mt-2 tw-mb-0 tw-text-[16px] tw-text-jr-mute",
                                                            children: s.desc
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, s.title);
                                    })
                                })
                            ]
                        })
                    ]
                }, key);
            }
        case "careSteps":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                className: "!tw-py-8 md:!tw-py-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-border tw-border-jr-line tw-bg-white tw-p-6 md:tw-p-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(H2, {
                            className: "!tw-text-[26px] md:!tw-text-[34px]",
                            children: b.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-mt-8 tw-grid tw-gap-8 md:tw-grid-cols-3",
                            children: b.items.map(function(it, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "tw-m-0 tw-text-[12px] tw-text-jr-gold",
                                            children: String(i + 1).padStart(2, "0")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "".concat(serif, " tw-mt-3 tw-mb-0 tw-text-[24px] tw-font-normal"),
                                            children: it.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-mt-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink, {
                                                href: "/tin-tuc/?q=".concat(encodeURIComponent(it.q)),
                                                children: "Đọc hướng dẫn"
                                            })
                                        })
                                    ]
                                }, it.title);
                            })
                        })
                    ]
                })
            }, key);
        case "productLines":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHead, {
                        title: b.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-grid tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-5 tw-gap-4",
                        children: b.items.map(function(p) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(A, {
                                href: p.href,
                                className: "tw-block tw-text-jr-ink",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: p.image,
                                        alt: p.title,
                                        loading: "lazy",
                                        className: "tw-aspect-square tw-w-full tw-object-cover tw-bg-black"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "tw-mt-3 tw-flex tw-items-center tw-justify-between tw-text-[16px]",
                                        children: [
                                            p.title,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {})
                                        ]
                                    })
                                ]
                            }, p.title);
                        })
                    })
                ]
            }, key);
        case "split":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                className: "!tw-py-8 md:!tw-py-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-grid tw-gap-8 md:tw-grid-cols-2 tw-items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: b.image,
                            alt: b.title.replace("\n", " "),
                            loading: "lazy",
                            className: "tw-w-full tw-max-w-[550px] tw-aspect-square tw-object-cover tw-bg-black"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "md:tw-pl-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-m-0 tw-text-[12px] tw-font-medium tw-uppercase tw-tracking-[0.08em] tw-text-jr-plum",
                                    children: b.eyebrow
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(H2, {
                                    className: "tw-mt-4 tw-whitespace-pre-line",
                                    children: b.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-mt-4 tw-mb-0 tw-text-[17px] tw-text-jr-mute tw-max-w-[420px]",
                                    children: b.lead
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-mt-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                        href: "#bai-viet",
                                        tone: "plum",
                                        children: b.cta
                                    })
                                })
                            ]
                        })
                    ]
                })
            }, key);
        case "banner":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                className: "!tw-py-8 md:!tw-py-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-grid tw-gap-6 md:tw-grid-cols-[1fr_auto] md:tw-items-center tw-p-6 md:tw-p-10 ".concat(b.tone === "rose" ? "tw-bg-jr-rose" : "tw-bg-jr-band"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                b.eyebrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(Eyebrow, {
                                    children: b.eyebrow
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(H2, {
                                    className: "".concat(b.eyebrow ? "tw-mt-3" : "", " !tw-text-[26px] md:!tw-text-[34px]"),
                                    children: b.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-mt-3 tw-mb-0 tw-text-[17px] tw-text-jr-mute tw-max-w-[560px]",
                                    children: b.lead
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                            href: b.href,
                            tone: b.tone === "rose" ? "plum" : "green",
                            children: b.cta
                        })
                    ]
                })
            }, key);
        case "articles":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                id: "bai-viet",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHead, {
                        title: b.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleList, {
                        items: articles,
                        intro: b.intro
                    })
                ]
            }, key);
        default:
            return null;
    }
};
var TopicsGrid = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-grid tw-gap-4 md:tw-grid-cols-3",
        children: journal_const/* JOURNAL_TOPICS.map */.sJ.map(function(t, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(A, {
                href: t.slug === "bang-gia" ? "/bang-gia/" : (0,journal_const/* topicHref */.hR)(t.slug),
                className: "tw-group tw-flex tw-flex-col tw-justify-between tw-border tw-border-jr-line tw-bg-white tw-p-5 tw-text-jr-ink hover:tw-border-jr-green",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-items-start tw-gap-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: t.tile,
                                alt: "",
                                loading: "lazy",
                                className: "tw-h-[88px] tw-w-[88px] tw-shrink-0 tw-object-cover tw-bg-black"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-m-0 tw-text-[12px] tw-text-jr-gold",
                                        children: String(i + 1).padStart(2, "0")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "".concat(serif, " tw-mt-1 tw-mb-0 tw-text-[24px] tw-font-normal tw-leading-tight group-hover:tw-text-jr-green"),
                                        children: t.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-mt-2 tw-mb-0 tw-text-[13px] tw-text-jr-mute",
                                        children: t.summary
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "tw-mt-5 tw-mb-0 tw-text-[14px] tw-font-medium tw-text-jr-green",
                        children: [
                            "Xem chuy\xean đề ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {})
                        ]
                    })
                ]
            }, t.slug);
        })
    });
};



/***/ }),

/***/ 89365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IO": function() { return /* binding */ PAGE_TOPICS; },
/* harmony export */   "cx": function() { return /* binding */ NAV_ITEMS; },
/* harmony export */   "hR": function() { return /* binding */ topicHref; },
/* harmony export */   "sJ": function() { return /* binding */ JOURNAL_TOPICS; },
/* harmony export */   "wp": function() { return /* binding */ TOPIC_BY_SLUG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);
/**
 * An Thư Journal — cấu hình 6 chuyên đề của khu /tin-tuc/.
 * Nội dung chữ trên trang chuyên đề (hero, thẻ, khối) lấy theo bản thiết kế
 * design/landing-page-news/an-thu-ui-tron-bo. Muốn đổi chữ / link: sửa ở file này.
 */ 


var APPOINTMENT = "/accounts/appointment/new";
var q = function(s) {
    return "/tin-tuc/?q=".concat(encodeURIComponent(s));
};
var JOURNAL_TOPICS = [
    {
        slug: "bang-gia",
        title: "Bảng gi\xe1",
        tag: "BẢNG GI\xc1",
        summary: "Gi\xe1 v\xe0ng \xb7 Tỷ gi\xe1 ngoại tệ \xb7 Kim cương",
        tile: "/journal/tile-bang-gia.jpg",
        hero: {
            tone: "beige",
            eyebrow: "",
            title: [],
            lead: ""
        },
        seoTitle: "",
        seoDescription: "",
        faq: [],
        blocks: [],
        match: /^$/
    },
    {
        slug: "kiem-dinh",
        title: "Kiểm định",
        tag: "KIỂM ĐỊNH",
        summary: "GIA \xb7 IGI \xb7 Liulab \xb7 DOJI \xb7 SJC",
        tile: "/journal/tile-kiem-dinh.jpg",
        hero: {
            tone: "beige",
            eyebrow: "KIỂM ĐỊNH KIM CƯƠNG",
            title: [
                "An t\xe2m từ",
                "những th\xf4ng tin r\xf5 r\xe0ng."
            ],
            lead: "T\xecm hiểu c\xe1c đơn vị kiểm định v\xe0 c\xe1ch đọc chứng thư trước khi lựa chọn kim cương.",
            image: "/journal/chung-thu.jpg",
            cta: {
                label: "Tư vấn c\xf9ng An Thư",
                href: APPOINTMENT,
                tone: "green"
            },
            imageContain: true
        },
        seoTitle: "Kiểm định kim cương: đọc giấy chứng thư",
        seoDescription: "C\xe1ch đọc giấy kiểm định kim cương, t\xecm hiểu GIA, IGI, Liulab, DOJI, SJC trước khi mua. Kiến thức từ An Thư The Diamond Store, TP.HCM.",
        faq: [
            {
                q: "Kim cương tại An Thư c\xf3 giấy kiểm định của đơn vị n\xe0o?",
                a: "Mỗi vi\xean kim cương chủ tại An Thư c\xf3 giấy kiểm định của Liulab, DOJI hoặc SJC. Số giấy kiểm định được in ngay tr\xean trang sản phẩm để bạn đối chiếu."
            },
            {
                q: "Giấy kiểm định kim cương cho biết những g\xec?",
                a: "Giấy kiểm định ghi đơn vị cấp, m\xe3 số chứng thư, h\xecnh dạng v\xe0 gi\xe1c cắt, k\xedch thước, trọng lượng (carat), cấp độ m\xe0u v\xe0 độ tinh khiết của vi\xean kim cương. Đ\xe2y l\xe0 cơ sở để so s\xe1nh c\xe1c vi\xean với nhau trước khi quyết định mua."
            },
            {
                q: "T\xf4i chưa hiểu giấy kiểm định th\xec hỏi ai?",
                a: "An Thư c\xf3 một showroom duy nhất tại 89A Nguyễn Tr\xe3i, Phường Bến Th\xe0nh, TP. Hồ Ch\xed Minh, mở cửa 09:00–21:00 hằng ng\xe0y. Hotline 033 333 6789. Bạn c\xf3 thể mang giấy kiểm định đến để được tư vấn trực tiếp."
            }, 
        ],
        blocks: [
            {
                type: "institutions",
                title: "T\xecm hiểu đơn vị kiểm định",
                items: [
                    "GIA",
                    "IGI",
                    "Liulab",
                    "DOJI",
                    "SJC"
                ]
            },
            {
                type: "readGuide",
                title: "C\xe1ch đọc giấy kiểm định",
                lead: "Đi từ th\xf4ng tin nhận diện đến c\xe1c th\xf4ng số chất lượng.",
                steps: [
                    {
                        title: "Th\xf4ng tin nhận diện",
                        desc: "Đơn vị cấp, m\xe3 chứng thư v\xe0 th\xf4ng tin vi\xean kim cương."
                    },
                    {
                        title: "C\xe1c ti\xeau ch\xed chất lượng",
                        desc: "K\xedch thước, trọng lượng v\xe0 c\xe1c mục đ\xe1nh gi\xe1 tr\xean giấy."
                    },
                    {
                        title: "Đối chiếu & tư vấn",
                        desc: "Đọc hướng dẫn của An Thư hoặc mang giấy để được hỗ trợ."
                    }, 
                ],
                cta: "Đọc hướng dẫn kiểm định"
            },
            {
                type: "articles",
                title: "B\xe0i viết về kiểm định"
            },
            {
                type: "cards",
                cols: 3,
                items: [
                    {
                        title: "Giấy của t\xf4i thuộc đơn vị n\xe0o?",
                        desc: "Xem phần hỏi đ\xe1p của An Thư.",
                        href: "/hoi-dap/",
                        label: "Kh\xe1m ph\xe1"
                    },
                    {
                        title: "Gi\xe1 & chất lượng",
                        desc: "Kết nối kiểm định với lựa chọn.",
                        href: "/bang-gia/",
                        label: "Kh\xe1m ph\xe1"
                    },
                    {
                        title: "T\xecm hiểu kim cương",
                        desc: "Kh\xe1m ph\xe1 4C v\xe0 c\xe1c gi\xe1c cắt.",
                        href: "/tin-tuc/kien-thuc-kim-cuong/",
                        label: "Kh\xe1m ph\xe1"
                    }, 
                ]
            }, 
        ],
        match: /kiem dinh|chung thu|giay chung nhan|liulab|doji|\bsjc\b/
    },
    {
        slug: "kim-cuong",
        title: "Kim cương",
        tag: "KIM CƯƠNG",
        summary: "4C \xb7 Li & carat \xb7 Tự nhi\xean & nh\xe2n tạo",
        tile: "/journal/tile-kim-cuong.jpg",
        hero: {
            tone: "dark",
            eyebrow: "THẾ GIỚI KIM CƯƠNG",
            title: [
                "Vẻ đẹp bắt đầu",
                "từ sự thấu hiểu."
            ],
            lead: "Kh\xe1m ph\xe1 4C, k\xedch thước, nguồn gốc v\xe0 những sắc th\xe1i của trang sức đ\xe1 qu\xfd.",
            image: "/journal/hero-ring.jpg",
            cta: {
                label: "Tư vấn c\xf9ng An Thư",
                href: APPOINTMENT,
                tone: "gold"
            }
        },
        seoTitle: "Kim cương: 4C, carat, tự nhi\xean v\xe0 nh\xe2n tạo",
        seoDescription: "T\xecm hiểu 4C (gi\xe1c cắt, m\xe0u sắc, độ tinh khiết, carat), kim cương tự nhi\xean v\xe0 nh\xe2n tạo. Kiến thức từ An Thư The Diamond Store, TP.HCM.",
        faq: [
            {
                q: "4C của kim cương l\xe0 g\xec?",
                a: "4C l\xe0 bốn ti\xeau ch\xed đ\xe1nh gi\xe1 kim cương: Cut (gi\xe1c cắt), Color (m\xe0u sắc), Clarity (độ tinh khiết) v\xe0 Carat (trọng lượng). Hai vi\xean c\xf9ng carat vẫn c\xf3 thể kh\xe1c gi\xe1 nếu kh\xe1c ở ba ti\xeau ch\xed c\xf2n lại."
            },
            {
                q: "Li v\xe0 carat kh\xe1c nhau thế n\xe0o?",
                a: "Li (milim\xe9t) l\xe0 k\xedch thước, thường l\xe0 đường k\xednh vi\xean đ\xe1 nh\xecn từ tr\xean xuống. Carat l\xe0 trọng lượng, 1 carat bằng 0,2 gram. Vi\xean tr\xf2n 1 carat thường c\xf3 đường k\xednh khoảng 6,4–6,5 mm; k\xedch thước thực tế c\xf2n phụ thuộc gi\xe1c cắt."
            },
            {
                q: "An Thư b\xe1n kim cương tự nhi\xean hay nh\xe2n tạo?",
                a: "An Thư b\xe1n trang sức kim cương tự nhi\xean, mỗi vi\xean chủ c\xf3 giấy kiểm định Liulab, DOJI hoặc SJC. Nhẫn c\xf3 gi\xe1 từ 8 đến 300 triệu đồng."
            }, 
        ],
        blocks: [
            {
                type: "steps",
                title: "Bắt đầu với 4C",
                items: [
                    {
                        en: "Cut",
                        vi: "Gi\xe1c cắt",
                        href: q("gi\xe1c cắt")
                    },
                    {
                        en: "Color",
                        vi: "M\xe0u sắc",
                        href: q("m\xe0u sắc")
                    },
                    {
                        en: "Clarity",
                        vi: "Độ tinh khiết",
                        href: q("tinh khiết")
                    },
                    {
                        en: "Carat",
                        vi: "Trọng lượng",
                        href: q("carat")
                    }, 
                ]
            },
            {
                type: "sizePanel"
            },
            {
                type: "cards",
                cols: 3,
                items: [
                    {
                        title: "Tự nhi\xean & nh\xe2n tạo",
                        desc: "T\xecm hiểu nguồn gốc v\xe0 c\xe1ch lựa chọn.",
                        href: q("nh\xe2n tạo"),
                        label: "Kh\xe1m ph\xe1"
                    },
                    {
                        title: "Ngọc trai & đ\xe1 qu\xfd",
                        desc: "Tư vấn chất liệu v\xe0 sắc m\xe0u.",
                        href: "/danh-muc/ngoc-trai-da-quy/",
                        label: "Kh\xe1m ph\xe1"
                    },
                    {
                        title: "Hiểu giấy kiểm định",
                        desc: "Đối chiếu c\xe1c ti\xeau ch\xed của từng vi\xean.",
                        href: "/tin-tuc/kiem-dinh/",
                        label: "Kh\xe1m ph\xe1"
                    }, 
                ]
            },
            {
                type: "articles",
                title: "Kh\xe1m ph\xe1 s\xe2u hơn",
                intro: true
            }, 
        ],
        match: /4c|giac cat|tinh khiet|cap do mau|mau sac|carat|huynh quang|tu nhien|nhan tao|lab-?grown|kim cuong tu nhien/
    },
    {
        slug: "nhan-cuoi",
        title: "Nhẫn cưới",
        tag: "NHẪN CƯỚI & Đ\xcdNH H\xd4N",
        summary: "Cầu h\xf4n \xb7 Nhẫn cưới \xb7 Đo ni \xb7 Ng\xe2n s\xe1ch",
        tile: "/journal/tile-nhan-cuoi.jpg",
        hero: {
            tone: "rose",
            eyebrow: "CẦU H\xd4N & NHẪN CƯỚI",
            title: [
                "Một lời hẹn.",
                "Một đời n\xe2ng niu."
            ],
            lead: "Chọn chiếc nhẫn d\xe0nh cho c\xe2u chuyện của hai bạn, từ khoảnh khắc cầu h\xf4n đến ng\xe0y cưới.",
            image: "/journal/hero-princess.jpg",
            cta: {
                label: "Tư vấn c\xf9ng An Thư",
                href: APPOINTMENT,
                tone: "green"
            }
        },
        seoTitle: "Nhẫn cưới, nhẫn cầu h\xf4n: đo ni v\xe0 ng\xe2n s\xe1ch",
        seoDescription: "Gợi \xfd chọn nhẫn cầu h\xf4n, nhẫn cưới kim cương, c\xe1ch đo ni v\xe0 c\xe2n đối ng\xe2n s\xe1ch. Cảm hứng từ An Thư The Diamond Store, TP.HCM.",
        faq: [
            {
                q: "Nhẫn kim cương tại An Thư c\xf3 gi\xe1 từ bao nhi\xeau?",
                a: "Nhẫn kim cương tại An Thư c\xf3 gi\xe1 từ 8 đến 300 triệu đồng, gi\xe1 ni\xeam yết c\xf4ng khai tr\xean anthu.vn."
            },
            {
                q: "An Thư c\xf3 sửa ni nhẫn miễn ph\xed kh\xf4ng?",
                a: "An Thư sửa ni miễn ph\xed trong 3 ni. C\xe1c trường hợp ngo\xe0i mức n\xe0y được t\xednh ph\xed theo gi\xe1."
            },
            {
                q: "Đặt cọc nhẫn tại An Thư như thế n\xe0o?",
                a: "Mức đặt cọc tối thiểu l\xe0 10% gi\xe1 trị sản phẩm v\xe0 phần c\xf2n lại được thanh to\xe1n trong 3 ng\xe0y. Nếu hủy, khoản cọc sẽ kh\xf4ng được ho\xe0n lại. Chi tiết tại trang ch\xednh s\xe1ch đặt cọc của An Thư."
            }, 
        ],
        blocks: [
            {
                type: "cards",
                cols: 4,
                items: [
                    {
                        title: "Nhẫn cầu h\xf4n",
                        desc: "Kh\xe1m ph\xe1 cảm hứng đ\xednh h\xf4n.",
                        href: q("cầu h\xf4n"),
                        label: "Kh\xe1m ph\xe1"
                    },
                    {
                        title: "Nhẫn cưới",
                        desc: "Tham khảo c\xe1c thiết kế để giới thiệu.",
                        href: q("nhẫn cưới"),
                        label: "Kh\xe1m ph\xe1"
                    },
                    {
                        title: "Đo ni nhẫn",
                        desc: "Hướng dẫn k\xedch thước & quy đổi size.",
                        href: "/guide-to-measuring-hands/",
                        label: "Kh\xe1m ph\xe1"
                    },
                    {
                        title: "Ng\xe2n s\xe1ch",
                        desc: "Tư vấn để chọn chiếc nhẫn ph\xf9 hợp.",
                        href: q("ng\xe2n s\xe1ch"),
                        label: "Kh\xe1m ph\xe1"
                    }, 
                ]
            },
            {
                type: "split",
                image: "/journal/heart-ring.jpg",
                eyebrow: "KHOẢNH KHẮC CẦU H\xd4N",
                title: "Dấu ấn ri\xeang\ncho lời y\xeau của bạn.",
                lead: "T\xecm cảm hứng từ gi\xe1c cắt Heart v\xe0 những thiết kế An Thư đ\xe3 giới thiệu.",
                cta: "Kh\xe1m ph\xe1 cảm hứng"
            },
            {
                type: "banner",
                tone: "rose",
                title: "Vừa vặn tr\xean tay. Ph\xf9 hợp trong lựa chọn.",
                lead: "Đo ni tại cửa h\xe0ng v\xe0 trao đổi ng\xe2n s\xe1ch để c\xf9ng An Thư t\xecm chiếc nhẫn d\xe0nh cho hai bạn.",
                cta: "Hướng dẫn đo ni",
                href: "/guide-to-measuring-hands/"
            },
            {
                type: "articles",
                title: "Cảm hứng cho lời hẹn"
            }, 
        ],
        match: /nhan cuoi|cau hon|dinh hon|do ni|size nhan|nhan doi|top 10 mau nhan|heart|emerald|princess|round cut/
    },
    {
        slug: "trang-suc",
        title: "Trang sức",
        tag: "TRANG SỨC & QU\xc0 TẶNG",
        summary: "Phong c\xe1ch \xb7 Qu\xe0 tặng \xb7 Phong thuỷ",
        tile: "/journal/tile-trang-suc.jpg",
        hero: {
            tone: "plain",
            eyebrow: "TRANG SỨC AN THƯ",
            title: [
                "Dấu ấn của ri\xeang bạn."
            ],
            lead: "Kh\xe1m ph\xe1 trang sức qua phong c\xe1ch, dịp tặng v\xe0 những điều bạn tr\xe2n qu\xfd."
        },
        seoTitle: "Trang sức kim cương: phong c\xe1ch v\xe0 qu\xe0 tặng",
        seoDescription: "Cảm hứng chọn trang sức kim cương theo phong c\xe1ch, dịp tặng qu\xe0 v\xe0 quan niệm phong thuỷ. B\xe0i viết từ An Thư The Diamond Store, TP.HCM.",
        faq: [
            {
                q: "Showroom An Thư ở đ\xe2u, mở cửa l\xfac n\xe0o?",
                a: "An Thư c\xf3 một showroom duy nhất tại 89A Nguyễn Tr\xe3i, Phường Bến Th\xe0nh, TP. Hồ Ch\xed Minh, mở cửa 09:00–21:00 hằng ng\xe0y. Hotline 033 333 6789."
            },
            {
                q: "Kh\xf4ng đến showroom được th\xec mua trang sức An Thư thế n\xe0o?",
                a: "Bạn c\xf3 thể mua qua website anthu.vn, app An Thư hoặc livestream, v\xe0 nhận h\xe0ng giao tận nơi tr\xean to\xe0n quốc."
            },
            {
                q: "Ch\xednh s\xe1ch thu đổi trang sức của An Thư ra sao?",
                a: "Đổi lớn hoặc đổi ngang được t\xednh 0%. Khi thu lại, An Thư trừ 25% với gi\xe1 trị dưới 200 triệu, 20% với từ 200 đến dưới 500 triệu v\xe0 18% với từ 500 triệu trở l\xean. Chi tiết tại trang ch\xednh s\xe1ch thu đổi."
            }, 
        ],
        blocks: [
            {
                type: "productLines",
                title: "Chọn d\xf2ng trang sức",
                items: [
                    {
                        title: "Nhẫn nữ",
                        href: "/danh-muc/nhan-nu/",
                        image: "/journal/line-1.jpg"
                    },
                    {
                        title: "B\xf4ng tai",
                        href: "/danh-muc/bong-tai/",
                        image: "/journal/line-2.jpg"
                    },
                    {
                        title: "Mặt d\xe2y",
                        href: "/danh-muc/mat-day-chuyen/",
                        image: "/journal/line-3.jpg"
                    },
                    {
                        title: "V\xf2ng & lắc",
                        href: "/danh-muc/vong-tay/",
                        image: "/journal/line-4.jpg"
                    },
                    {
                        title: "Trang sức nam",
                        href: "/danh-muc/trang-suc-nam/",
                        image: "/journal/line-5.jpg"
                    }, 
                ]
            },
            {
                type: "cards",
                cols: 3,
                items: [
                    {
                        title: "Qu\xe0 tặng",
                        desc: "T\xecm cảm hứng cho người bạn y\xeau thương.",
                        href: q("qu\xe0 tặng"),
                        label: "Kh\xe1m ph\xe1"
                    },
                    {
                        title: "Trang sức nam",
                        desc: "Kh\xe1m ph\xe1 lựa chọn từ An Thư.",
                        href: "/danh-muc/trang-suc-nam/",
                        label: "Kh\xe1m ph\xe1"
                    },
                    {
                        title: "Phong thuỷ",
                        desc: "C\xe2u chuyện & quan niệm về trang sức.",
                        href: q("phong thủy"),
                        label: "Kh\xe1m ph\xe1"
                    }, 
                ]
            },
            {
                type: "articles",
                title: "Cảm hứng & c\xe2u chuyện trang sức",
                intro: true
            }, 
        ],
        match: /trang suc|qua tang|phong thuy|xu huong|bong tai|toi gian|ngoc cam thach|da quy/
    },
    {
        slug: "vang-bao-quan",
        title: "V\xe0ng & bảo quản",
        tag: "BẢO QUẢN",
        summary: "Chất liệu \xb7 Chăm s\xf3c \xb7 Sửa chữa",
        tile: "/journal/tile-vang-bao-quan.jpg",
        hero: {
            tone: "beige",
            eyebrow: "CHẤT LIỆU & CHĂM S\xd3C",
            title: [
                "G\xecn giữ vẻ đẹp",
                "qua năm th\xe1ng."
            ],
            lead: "T\xecm hiểu chất liệu, c\xe1ch bảo quản v\xe0 dịch vụ chăm s\xf3c trang sức tại An Thư.",
            image: "/journal/hero-bracelet.jpg",
            cta: {
                label: "Tư vấn c\xf9ng An Thư",
                href: APPOINTMENT,
                tone: "green"
            }
        },
        seoTitle: "Bảo quản trang sức v\xe0ng, kim cương đ\xfang c\xe1ch",
        seoDescription: "Hướng dẫn bảo quản, l\xe0m sạch trang sức v\xe0ng, kim cương v\xe0 đ\xe1 qu\xfd tại nh\xe0, c\xf9ng th\xf4ng tin sửa ni từ An Thư The Diamond Store, TP.HCM.",
        faq: [
            {
                q: "L\xe0m sạch trang sức kim cương tại nh\xe0 thế n\xe0o?",
                a: "Ng\xe2m trang sức v\xe0i ph\xfat trong nước ấm pha x\xe0 ph\xf2ng dịu, chải nhẹ bằng b\xe0n chải mềm, tr\xe1ng lại bằng nước sạch rồi lau kh\xf4 bằng khăn mềm. Tr\xe1nh d\xf9ng h\xf3a chất mạnh như chất tẩy chứa clo."
            },
            {
                q: "An Thư c\xf3 sửa ni miễn ph\xed kh\xf4ng?",
                a: "An Thư sửa ni miễn ph\xed trong 3 ni. C\xe1c trường hợp ngo\xe0i mức n\xe0y được t\xednh ph\xed theo gi\xe1."
            },
            {
                q: "Mang trang sức đến đ\xe2u để được kiểm tra v\xe0 tư vấn?",
                a: "An Thư c\xf3 một showroom duy nhất tại 89A Nguyễn Tr\xe3i, Phường Bến Th\xe0nh, TP. Hồ Ch\xed Minh, mở cửa 09:00–21:00 hằng ng\xe0y. Hotline 033 333 6789."
            }, 
        ],
        blocks: [
            {
                type: "cards",
                cols: 3,
                items: [
                    {
                        title: "V\xe0ng 14K \xb7 18K \xb7 24K",
                        desc: "T\xecm hiểu trước khi chọn chất liệu.",
                        href: q("v\xe0ng"),
                        label: "Kh\xe1m ph\xe1"
                    },
                    {
                        title: "V\xe0ng trắng & bạch kim",
                        desc: "Tham khảo b\xe0i viết về mặt d\xe2y.",
                        href: q("v\xe0ng trắng"),
                        label: "Kh\xe1m ph\xe1"
                    },
                    {
                        title: "Kim cương & đ\xe1 qu\xfd",
                        desc: "Chọn c\xe1ch chăm s\xf3c theo m\xf3n trang sức.",
                        href: q("đ\xe1 qu\xfd"),
                        label: "Kh\xe1m ph\xe1"
                    }, 
                ]
            },
            {
                type: "careSteps",
                title: "Chăm s\xf3c bắt đầu từ th\xf3i quen.",
                items: [
                    {
                        title: "Bảo quản tại nh\xe0",
                        q: "bảo quản"
                    },
                    {
                        title: "L\xe0m sạch trang sức",
                        q: "l\xe0m sạch"
                    },
                    {
                        title: "Chăm s\xf3c đ\xe1 qu\xfd",
                        q: "đ\xe1 qu\xfd"
                    }, 
                ]
            },
            {
                type: "articles",
                title: "Hướng dẫn từ An Thư"
            },
            {
                type: "banner",
                tone: "beige",
                eyebrow: "SỬA CHỮA & BẢO H\xc0NH",
                title: "Mang trang sức đến An Thư.",
                lead: "Trao đổi t\xecnh trạng sản phẩm để được tư vấn dịch vụ ph\xf9 hợp.",
                cta: "Xem ch\xednh s\xe1ch bảo h\xe0nh",
                href: "/policies/product-warranty/"
            }, 
        ],
        match: /bao quan|lam sach|ve sinh|vang 14|vang 18|vang 24|vang trang|sua ni|bao hanh|cham soc|siet chau|danh bong/
    }, 
];
var TOPIC_BY_SLUG = JOURNAL_TOPICS.reduce(function(acc, t) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, t.slug, t));
}, {});
var PAGE_TOPICS = JOURNAL_TOPICS.filter(function(t) {
    return t.slug !== "bang-gia";
});
/** Navigation labels are shared by desktop and mobile Journal headers. */ var NAV_ITEMS = [
    {
        label: "Kiến Thức Kim Cương",
        href: "/tin-tuc/kien-thuc-kim-cuong/",
        key: "kim-cuong"
    },
    {
        label: "Kiến Thức Trang Sức",
        href: "/tin-tuc/kien-thuc-trang-suc/",
        key: "trang-suc"
    },
    {
        label: "Tin Tức An Thư",
        href: "/tin-tuc/tin-an-thu/",
        key: "tin-an-thu"
    },
    {
        label: "B\xe1o Ch\xed",
        href: "/tin-tuc/bao-chi/",
        key: "bao-chi"
    },
    {
        label: "Khuyến M\xe3i",
        href: "/tin-tuc/khuyen-mai/",
        key: "khuyen-mai"
    },
    {
        label: "Bảng Gi\xe1",
        href: "/bang-gia/",
        key: "bang-gia"
    }, 
];
/** Public paths follow the current WordPress category slugs. */ var topicHref = function(slug) {
    return "/tin-tuc/".concat(slug === "kim-cuong" ? "kien-thuc-kim-cuong" : slug === "trang-suc" ? "kien-thuc-trang-suc" : slug, "/");
};


/***/ }),

/***/ 71744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QZ": function() { return /* binding */ GIA_LOOKUP_HREF; },
/* harmony export */   "qb": function() { return /* binding */ marketFragmentPath; },
/* harmony export */   "x_": function() { return /* binding */ MARKET_PAGES; }
/* harmony export */ });
/* unused harmony export MARKET_FRAGMENT_PAGES */
var MARKET_PAGES = {
    overview: {
        path: "/bang-gia/",
        label: "Bảng gi\xe1",
        title: "Bảng gi\xe1 v\xe0ng, tỷ gi\xe1 ngoại tệ v\xe0 gi\xe1 kim cương",
        description: "Tra cứu gi\xe1 v\xe0ng trong nước, tỷ gi\xe1 ngoại tệ Vietcombank v\xe0 c\xf4ng cụ tham khảo gi\xe1 kim cương tự nhi\xean. C\xf3 nguồn dữ liệu, đơn vị v\xe0 thời gian cập nhật.",
        heading: "Bảng gi\xe1 tham khảo.",
        intro: "Gi\xe1 v\xe0ng trong nước, tỷ gi\xe1 ngoại tệ v\xe0 gi\xe1 tham khảo kim cương quốc tế."
    },
    gold: {
        path: "/bang-gia/gia-vang/",
        label: "Gi\xe1 v\xe0ng",
        title: "Gi\xe1 v\xe0ng h\xf4m nay: bảng gi\xe1 mua v\xe0o, b\xe1n ra",
        description: "Bảng gi\xe1 v\xe0ng mua v\xe0o, b\xe1n ra theo thương hiệu trong nước, đơn vị ngh\xecn đồng/chỉ. Xem biến động, nguồn tham khảo v\xe0 thời gian cập nhật dữ liệu.",
        heading: "Gi\xe1 v\xe0ng h\xf4m nay.",
        intro: "Theo d\xf5i gi\xe1 mua v\xe0o, b\xe1n ra v\xe0 biến động theo từng thương hiệu trong nước."
    },
    forex: {
        path: "/bang-gia/ty-gia/",
        label: "Tỷ gi\xe1 ngoại tệ",
        title: "Tỷ gi\xe1 ngoại tệ Vietcombank: USD, EUR, JPY v\xe0 c\xe1c đồng kh\xe1c",
        description: "Tra cứu tỷ gi\xe1 ngoại tệ Vietcombank: USD, EUR, JPY, CNY, KRW v\xe0 c\xe1c đồng kh\xe1c. So s\xe1nh mua tiền mặt, chuyển khoản v\xe0 b\xe1n ra theo VND.",
        heading: "Tỷ gi\xe1 ngoại tệ.",
        intro: "So s\xe1nh gi\xe1 mua tiền mặt, mua chuyển khoản v\xe0 b\xe1n ra theo nguồn Vietcombank."
    },
    diamond: {
        path: "/bang-gia/kim-cuong/",
        label: "Gi\xe1 kim cương",
        title: "Gi\xe1 kim cương tự nhi\xean: tra cứu theo 4C v\xe0 b\xe1o c\xe1o GIA",
        description: "Tham khảo gi\xe1 kim cương tự nhi\xean theo carat, m\xe0u sắc, độ tinh khiết v\xe0 gi\xe1c cắt từ StoneAlgo. Nhập số b\xe1o c\xe1o để đối chiếu tại GIA Report Check.",
        heading: "Gi\xe1 kim cương tự nhi\xean.",
        intro: "Tham khảo gi\xe1 theo th\xf4ng số 4C v\xe0 đối chiếu th\xf4ng tin b\xe1o c\xe1o GIA của vi\xean đ\xe1."
    }
};
var GIA_LOOKUP_HREF = "".concat(MARKET_PAGES.diamond.path, "#tra-cuu-gia");
var MARKET_FRAGMENT_PAGES = {
    "gia-vang": "gold",
    "bang-gia-vang": "gold",
    "ty-gia-usd": "forex",
    "ty-gia": "forex",
    "gia-kim-cuong": "diamond"
};
var marketFragmentPath = function(fragment) {
    if (!Object.prototype.hasOwnProperty.call(MARKET_FRAGMENT_PAGES, fragment)) return null;
    return MARKET_PAGES[MARKET_FRAGMENT_PAGES[fragment]].path;
};


/***/ }),

/***/ 16356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Id": function() { return /* binding */ pressSource; },
/* harmony export */   "Kd": function() { return /* binding */ plainText; },
/* harmony export */   "VM": function() { return /* binding */ articleSource; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);
/** Convert CMS HTML titles to text. Render the result as React text, never HTML. */ 

var plainText = function(value) {
    var named = {
        amp: "&",
        nbsp: " ",
        quot: '"',
        apos: "'",
        lt: "<",
        gt: ">",
        ndash: "–",
        mdash: "—",
        hellip: "…",
        lsquo: "‘",
        rsquo: "’",
        ldquo: "“",
        rdquo: "”"
    };
    return (value || "").replace(/<[^>]*>/g, "").replace(/&(#x[\da-f]+|#\d+|[a-z]+);/gi, function(entity, key) {
        var ref;
        if (key[0] !== "#") return (ref = named[key.toLowerCase()]) !== null && ref !== void 0 ? ref : entity;
        var point = key[1].toLowerCase() === "x" ? parseInt(key.slice(2), 16) : Number(key.slice(1));
        return point > 0 && point <= 0x10ffff && !(point >= 0xd800 && point <= 0xdfff) ? String.fromCodePoint(point) : entity;
    }).replace(/\s+/g, " ").trim();
};
/** Only absolute HTTP(S) source URLs supplied by the CMS are clickable. */ var articleSource = function(value) {
    try {
        var url = new URL(value);
        if (![
            "https:",
            "http:"
        ].includes(url.protocol) || url.username || url.password) return null;
        return {
            href: url.href,
            label: url.hostname.replace(/^www\./, "")
        };
    } catch (_error) {
        return null;
    }
};
/** Import tool's explicit attribution marker distinguishes summaries from our reference guides. */ var pressSource = function(html) {
    var categorized = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref;
    if (!categorized && !/Nội dung được An Thư tóm lược từ bài gốc/i.test(plainText(html))) return null;
    var section = (ref = html.match(/<h[1-6]\b[^>]*>\s*Nguồn tham khảo\s*<\/h[1-6]>([\s\S]*)/i)) === null || ref === void 0 ? void 0 : ref[1];
    if (!section) return null;
    var anchor = section.match(/<a\b[^>]*\bhref\s*=\s*["']([^"']+)["'][^>]*>([\s\S]*?)<\/a>/i);
    var source = anchor && articleSource(plainText(anchor[1]));
    if (!source || /(^|\.)(anthu\.today|anthu\.vn)$/.test(new URL(source.href).hostname)) return null;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, source), {
        label: plainText(anchor[2]) || source.label
    });
};


/***/ })

}]);